import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  formateLocalDateAndTime,
} from "../../../utils/commonFunctions";
import { CalenderIcon, PaperClipIcon } from "../../Icon";
import { LoginResponseType } from "../../../redux/auth/authTypes";
type AppProps = {
  singleClientleadDirectoryDetails: any;

  loginData: LoginResponseType;
};
const LeadViewDetailsModal = ({
  singleClientleadDirectoryDetails,
  loginData,
}: AppProps) => {
  const scopeOfWorkArray = singleClientleadDirectoryDetails?.scope_of_work || [];

  const scopeOfWorkNames = scopeOfWorkArray.map((item:any) => item.scope_of_work_name).join(', ');
  return (
    <div>
      <div className="row  ml-2"></div>
      <div
        className="row ml-3 d-flex flex-column mb-2 mt-4"
        style={{
          border: "1px solid #bfcbe1",
          width: "93%",
          borderRadius: "6px",
        }}
      >
        <div className="ml-3 mt-3">
          <h5 style={{ fontSize: "15px", color: "#262a44", fontWeight: "600" }}>
            BASIC DETAILS
          </h5>
        </div>
        <div
          className="d-flex row justify-content-between ml-3 mb-3"
          style={{ width: "93%" }}
        >
          <div className="d-flex flex-column" style={{ width: "20%" }}>
            <span
              style={{
                color: "#6e7491",
                fontSize: "13px",
                marginBottom: "4px",
              }}
            >
              Entity
            </span>
            <span style={{ color: "#262a44", fontSize: "14px" }}>
              {singleClientleadDirectoryDetails?.entity
                ? singleClientleadDirectoryDetails?.entity
                : "NA"}
            </span>
          </div>
          <div className="d-flex flex-column">
            <span
              style={{
                color: "#6e7491",
                fontSize: "13px",
                marginBottom: "4px",
              }}
            >
              First Name
            </span>
            <span style={{ color: "#262a44", fontSize: "14px" }}>
              {singleClientleadDirectoryDetails?.first_name
                ? singleClientleadDirectoryDetails?.first_name
                : "NA"}
            </span>
          </div>
          <div className="d-flex flex-column">
            <span
              style={{
                color: "#6e7491",
                fontSize: "13px",
                marginBottom: "4px",
              }}
            >
              Last Name
            </span>
            <span style={{ color: "#262a44", fontSize: "14px" }}>
              {singleClientleadDirectoryDetails?.last_name
                ? singleClientleadDirectoryDetails?.last_name
                : "NA"}
            </span>
          </div>
          <div className="d-flex flex-column">
            <span
              style={{
                color: "#6e7491",
                fontSize: "13px",
                marginBottom: "4px",
              }}
            >
              Name
            </span>

            {singleClientleadDirectoryDetails?.company_name?.length > 12 ? (
              <OverlayTrigger
                placement="bottom"
                delay={{ show: 250, hide: 250 }}
                overlay={
                  <Tooltip id="button-view">
                    {`${singleClientleadDirectoryDetails?.company_name}`}
                  </Tooltip>
                }
              >
                <span style={{ color: "#262a44", fontSize: "14px" }}>
                  {`${singleClientleadDirectoryDetails?.company_name
                    .toLowerCase()
                    .substr(0, 12)}${
                    singleClientleadDirectoryDetails?.company_name?.length > 12
                      ? "..."
                      : ""
                  }`}
                </span>
              </OverlayTrigger>
            ) : singleClientleadDirectoryDetails?.company_name ? (
              `${singleClientleadDirectoryDetails?.company_name}`
            ) : (
              "NA"
            )}
          </div>
          <div className="d-flex flex-column">
            <span
              style={{
                color: "#6e7491",
                fontSize: "13px",
                marginBottom: "4px",
              }}
            >
              City
            </span>
            <span style={{ color: "#262a44", fontSize: "14px" }}>
              {singleClientleadDirectoryDetails?.city
                ? singleClientleadDirectoryDetails?.city
                : "NA"}
            </span>
          </div>
          <div className="d-flex flex-column">
            <span style={{ color: "#6e7491", fontSize: "13px" }}>
              Client Category
            </span>
            <span style={{ color: "#262a44", fontSize: "14px" }}>
              {singleClientleadDirectoryDetails?.client_category?.length
                ? singleClientleadDirectoryDetails?.client_category?.map(
                    (el: any) => {
                      return <div>{el}</div>;
                    }
                  )
                : "NA"}
            </span>
          </div>
        </div>
      </div>
      <div className="row ml-2" style={{ marginTop: "30px" }}>
        <div className="col-md-3">
          <label
            className="mb-1"
            htmlFor="Lead Received On"
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#6e7491",
              lineHeight: "23px",
            }}
          >
            Lead Received On
          </label>
          <div style={{ display: "flex" }}>
            {singleClientleadDirectoryDetails?.lead_received_on ? (
              <CalenderIcon />
            ) : (
              ""
            )}
            <p style={{ marginLeft: "4px" }}>
              {singleClientleadDirectoryDetails?.lead_received_on
                ? singleClientleadDirectoryDetails?.lead_received_on
                : "NA"}
            </p>
          </div>
        </div>
        <div className="col-md-6">
          <label
            htmlFor="businessNature"
            className="mb-1"
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#6e7491",
              lineHeight: "23px",
            }}
          >
            Business Nature
          </label>
          <p>
            {singleClientleadDirectoryDetails?.business_nature
              ? singleClientleadDirectoryDetails?.business_nature
              : "NA"}
          </p>
        </div>
      </div>
      <div className="row ml-2" style={{ width: "98%" }}>
        <div className="col-md-3">
          <label
            className="mb-1"
            htmlFor="Demo Assigned To"
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#6e7491",
              lineHeight: "23px",
            }}
          >
            Lead Assigned To
          </label>
          <p>
            {singleClientleadDirectoryDetails?.lead_assigned_to?.first_name
              ? singleClientleadDirectoryDetails?.lead_assigned_to?.first_name
              : "NA"}
            {singleClientleadDirectoryDetails?.lead_assigned_to?.last_name
              ? singleClientleadDirectoryDetails?.lead_assigned_to?.last_name
              : ""}
          </p>
        </div>
        <div className="col-md-3">
          <label
            className="mb-1"
            htmlFor="Demo Assigned To"
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#6e7491",
              lineHeight: "23px",
            }}
          >
            Demo Assigned To
          </label>
          <p>
            {singleClientleadDirectoryDetails?.demo_assigned_to?.first_name
              ? singleClientleadDirectoryDetails?.demo_assigned_to?.first_name
              : "NA"}{" "}
            {singleClientleadDirectoryDetails?.demo_assigned_to?.last_name}
          </p>
        </div>
        <div className="col-md-6">
          <label
            className="mb-1"
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#6e7491",
              lineHeight: "23px",
            }}
          >
            Access to Team Members
          </label>
          <p>
            {singleClientleadDirectoryDetails?.access_members
              ?.map((member: any) =>
                member?.user_id !== loginData?.user_id
                  ? `${member.first_name} ${member.last_name}`
                  : ""
              )
              .join(", ")}
          </p>
        </div>
      </div>
      <div className="row ml-2 mt-2">
        <div className="col-md-3">
          <label
            className="mb-1"
            htmlFor="meetingTimewithDate"
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#6e7491",
              lineHeight: "23px",
            }}
          >
            Meeting Assigned To
          </label>
          <p>
            {singleClientleadDirectoryDetails?.meeting_assigned_to?.first_name
              ? singleClientleadDirectoryDetails?.meeting_assigned_to
                  ?.first_name
              : "NA"}{" "}
            {singleClientleadDirectoryDetails?.meeting_assigned_to?.last_name}
          </p>
        </div>

        <div className="col-md-3">
          <label
            className="mb-1"
            htmlFor="meetingTimewithDate"
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#6e7491",
              lineHeight: "23px",
            }}
          >
            Meeting Date and Time
          </label>
          <div style={{ display: "flex" }}>
            {singleClientleadDirectoryDetails?.meeting_time ? (
              <p>
                <CalenderIcon />
              </p>
            ) : (
              ""
            )}
            <p style={{ marginLeft: "4px" }}>
              {singleClientleadDirectoryDetails?.meeting_time
                ? formateLocalDateAndTime(
                    singleClientleadDirectoryDetails?.meeting_time
                  )
                : "NA"}
            </p>
          </div>
        </div>
        <div className="col-md-3">
          <label
            className="mb-1"
            htmlFor="meetingTimewithDate"
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#6e7491",
              lineHeight: "23px",
            }}
          >
            Turnover (in crores)
          </label>
          <div style={{ display: "flex" }}>
            <p style={{ marginLeft: "4px" }}>
              {singleClientleadDirectoryDetails?.turnover_in_crores
                ? singleClientleadDirectoryDetails?.turnover_in_crores
                : "NA"}
            </p>
          </div>
        </div>
      </div>
      <p
        className="ml-4"
        style={{
          marginTop: "20px",
          marginBottom: "0px",
          fontSize: "15px",
          color: "#262a44",
          fontWeight: "600",
        }}
      >
        LEAD DETAILS
      </p>
      <div className="row ml-1 col-md-12">
        <div className="col-md-3 p-1">
          <label
            className="mb-1"
            htmlFor="Response"
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#6e7491",
              lineHeight: "23px",
            }}
          >
            Response
          </label>
          <p>
            {singleClientleadDirectoryDetails?.lead_details?.response
              ? singleClientleadDirectoryDetails?.lead_details?.response
              : "NA"}
          </p>
        </div>
        <div className="col-md-3 pt-1 pb-1">
          <label
            className="mb-1"
            htmlFor="Stage"
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#6e7491",
              lineHeight: "23px",
            }}
          >
            Stage
          </label>
          <p>
            {singleClientleadDirectoryDetails?.lead_details?.stage
              ? singleClientleadDirectoryDetails?.lead_details?.stage
              : "NA"}
          </p>
        </div>
        <div className="col-md-3 pt-1 pb-1">
          <label
            className="mb-1"
            htmlFor="Stage"
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#6e7491",
              lineHeight: "23px",
            }}
          >
            Call Frequency
          </label>
          <p>
            {singleClientleadDirectoryDetails?.lead_details?.call_frequency
              ? singleClientleadDirectoryDetails?.lead_details?.call_frequency
              : "NA"}
          </p>
        </div>
        <div className="col-md-3 pt-1 pb-1">
          <label
            className="mb-1"
            htmlFor="Source"
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#6e7491",
              lineHeight: "23px",
            }}
          >
            Source
          </label>
          <div className="d-flex flex-row position-relative">
            <p>
              {singleClientleadDirectoryDetails?.lead_details?.source
                ? singleClientleadDirectoryDetails?.lead_details?.source
                : "NA"}
            </p>
          </div>
        </div>
        <div className="col-md-9 mt-3 p-1">
          <label
            className="mb-1"
            htmlFor="Feedback"
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#6e7491",
              lineHeight: "23px",
            }}
          >
            Feedback
          </label>
          <p>
            {singleClientleadDirectoryDetails?.lead_details?.feedback
              ? singleClientleadDirectoryDetails?.lead_details?.feedback
              : "NA"}
          </p>
        </div>
        <div className="col-md-3 mt-3 p-1 pl-3">
          <label
            className="mb-1"
            htmlFor="Stage"
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#6e7491",
              lineHeight: "23px",
            }}
          >
            Lead Category
          </label>
          <p>
            {singleClientleadDirectoryDetails?.lead_details?.lead_category
              ? singleClientleadDirectoryDetails?.lead_details?.lead_category
              : "NA"}
          </p>
        </div>
      </div>
      <p
        className="ml-4"
        style={{
          marginBottom: "0px",
          marginTop: "23px",
          fontSize: "15px",
          color: "#262a44",
          fontWeight: "600",
        }}
      >
        COMPANY DETAILS
      </p>
      <div className="row col-md-12 ml-1" style={{ marginLeft: "-4px" }}>
        <div className="col-md-3 p-1">
          <label
            className="mb-1"
            htmlFor="Company Name"
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#6e7491",
              lineHeight: "23px",
            }}
          >
            Company Name
          </label>
          <p>
            {singleClientleadDirectoryDetails?.company_details?.company_name
              ? singleClientleadDirectoryDetails?.company_details?.company_name
              : "NA"}
          </p>
        </div>
        <div className="col-md-3 pt-1 pb-1">
          <label
            className="mb-1"
            htmlFor="Contact Person Name"
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#6e7491",
              lineHeight: "23px",
            }}
          >
            Contact Person Name
          </label>
          <p>
            {singleClientleadDirectoryDetails?.company_details
              ?.contact_person_name
              ? singleClientleadDirectoryDetails?.company_details
                  ?.contact_person_name
              : "NA"}
          </p>
        </div>
        <div className="col-md-3 pt-1 pb-1">
          <label
            className="mb-1"
            htmlFor="Contact Number"
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#6e7491",
              lineHeight: "23px",
            }}
          >
            Contact Number
          </label>
          <p>
            {singleClientleadDirectoryDetails?.company_details?.contact_number
              ? singleClientleadDirectoryDetails?.company_details
                  ?.contact_number
              : "NA"}
          </p>
        </div>
        <div className="col-md-3 pt-1 pb-1">
          <label
            className="mb-1"
            htmlFor="Email ID"
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#6e7491",
              lineHeight: "23px",
            }}
          >
            Email ID
          </label>
          <p>
            {singleClientleadDirectoryDetails?.company_details?.email
              ? singleClientleadDirectoryDetails?.company_details?.email
              : "NA"}
          </p>
        </div>
      </div>
     

      <p
        className="ml-4"
        style={{
          marginBottom: "0px",
          marginTop: "23px",
          fontSize: "15px",
          color: "#262a44",
          fontWeight: "600",
        }}
      >
        SCOPE OF WORK DETAILS
      </p>
      <div className="row col-md-12 ml-1" style={{ marginLeft: "-4px" }}>
        <div className="col-md-3 p-1">
          <label
            className="mb-1"
            htmlFor="Company Name"
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#6e7491",
              lineHeight: "23px",
            }}
          >
            Scope of Work
          </label>
          <p>
          {scopeOfWorkNames ? scopeOfWorkNames : "NA"}
          </p>
        </div>
       
      </div>
      <div className=" row col-md-12 ml-1" style={{ marginLeft: "-4px" }}>
        <div className="col-md-3 p-1">
          <label
            className="mb-1"
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#6e7491",
              lineHeight: "23px",
            }}
            htmlFor="Email ID"
          >
            Do you have registered GST Number?
          </label>
          <p>
            {singleClientleadDirectoryDetails?.company_details
              ?.gst_number_registered
              ? "YES"
              : "NO"}
          </p>
        </div>
        <div className="col-md-3 pl-3">
          <label
            className="mb-1"
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#6e7491",
              lineHeight: "23px",
            }}
            htmlFor="Email ID"
          >
            Ready To Migrate in Finac
          </label>
          <p>
            {singleClientleadDirectoryDetails?.finac_migration_status
              ? "YES"
              : "NO"}
          </p>
        </div>
        <div className="col-md-3 pt-1 pb-1">
          {singleClientleadDirectoryDetails?.attachments?.length ? (
            <label
              className="mb-1"
              style={{
                fontSize: "14px",
                fontWeight: "500",
                color: "#6e7491",
                lineHeight: "23px",
              }}
              htmlFor="Email ID"
            >
              File Count
            </label>
          ) : (
            ""
          )}
          <div className="position-relative ml-2 mt-2">
            {singleClientleadDirectoryDetails?.attachments?.length ? (
              <span id="Popover1" style={{ marginTop: "2px" }}>
                <PaperClipIcon />
                <span className="badge count-badge" style={{ left: "11px" }}>
                  {singleClientleadDirectoryDetails?.attachments?.length}
                </span>
              </span>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>

     
    </div>
  );
};

export default LeadViewDetailsModal;
